export const _getTr = word => `rm/${word}`
export const _getRm = word => `tr/${word}`
